{
  "es": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "Las quejas de spam no se pueden reactivar aquí. Esto solo se puede hacer manualmente a través de {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Buscar",
      "selected": "Seleccionado"
    }
  }
}
